module.exports = __webpack_public_path__ + "assets/img/logo.3f65abb5.png";